import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Fields from './fields';
import { adaptedName } from '../../utils/dataHelpers';
import { AppDataContext } from '../../context/Context';

export default class FilterItemsAbstract extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            permissions: {}
        };
    }
    static contextType = AppDataContext;

    componentDidMount() {
        this.setState({ permissions: this.context.getState().permissions });
        this.unsubscribe = this.context.subscribe(() => {
            this.setState({ permissions: this.context.getState().permissions });
        });
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    hasPermissions = () => {
        return !!Object.keys(this.state.permissions).length;
    };

    allowedPermission = (action, controller = this.props.controller) => {
        const adaptedController = adaptedName(controller);
        const { permissions } = this.state;

        const permission = this.hasPermissions()
            ? permissions?.[adaptedController]?.[action]
            : '';

        if (permission === 'allow_all') return true;
        if (permission === 'deny') return false;
    };
    handleFilterChange = (field, ids) => {
        const { filters = [] } = this.props;
        const nextFilters = ids.length
            ? this.updateOrAdd(filters, field, ids)
            : this.remove(filters, field);
        this.props.handleFilterItems(nextFilters);
    };

    updateOrAdd(filters, field, ids) {
        const filterIndex = filters.findIndex((f) => f.field === field);
        const newFilter = { field, op: '@', value: ids };

        if (filterIndex !== -1) {
            const updated = [...filters];
            updated[filterIndex] = newFilter;
            return updated;
        }
        return [...filters.flat(), newFilter];
    }

    remove(filters, field) {
        return filters.filter((f) => f.field !== field);
    }

    render() {
        const { Head, filters, params } = this.props;

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    width: '100%'
                }}
            >
                {Head.filter((f) => this.allowedPermission('read', f.from)).map(
                    (field) => {
                        if (!field.filterCell) return null;

                        const FieldComponent = Fields[field.filterCell];
                        return (
                            <FieldComponent
                                key={field.filterBy}
                                field={field}
                                handleFilter={this.handleFilterChange}
                                param={params?.id}
                                filters={filters}
                                disabled={this.props.disabled}
                                helperText={this.props.helperText}
                                maxWidth={this.props.maxWidth}
                                //sx={{ width: '100%', maxWidth: 300 }}
                            />
                        );
                    }
                )}
            </Box>
        );
    }
}

FilterItemsAbstract.defaultProps = {
    Head: [],
    filters: []
};

FilterItemsAbstract.propTypes = {
    Head: PropTypes.array.isRequired,
    handleFilterItems: PropTypes.func.isRequired,
    filters: PropTypes.array,
    params: PropTypes.object
};
